import { createGlobalStyle } from 'styled-components';

export type Colors =
    | 'primary'
    | 'primary-dark'
    | 'success'
    | 'success-hover'
    | 'danger'
    | 'danger-hover'
    | 'warning'
    | 'warning-background'
    | 'warning-border'
    | 'warning-text'
    | 'white'
    | 'black'
    | 'input-readonly';

export type TextColors = 'text-primary' | 'text-secondary' | 'text-dim' | Colors;
export const colorVar = (color: TextColors, layer?: 'fg' | 'bg') => `var(--color-${color}${layer ? `-${layer}` : ''})`;

export type Spacings = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'huge';
export const spacingVar = (spacing: Spacings) => `var(--spacing-${spacing})`;

export type FontWeights = 'normal' | 'medium' | 'semibold' | 'bold';
export const fontWeightVar = (weight: FontWeights) => `var(--font-weight-${weight})`;

export type FontFamilies = 'base' | 'mono';
export const fontFamilyVar = (family: FontFamilies) => `var(--font-family-${family})`;

export type FontSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export const fontSizeVar = (size: FontSize) => `var(--font-size-${size})`;

export type Radius = 'sm' | 'md' | 'lg' | 'xl';
export const radiusVar = (radius: Radius) => `var(--border-radius-${radius})`;

export const GlobalCssVars = createGlobalStyle`
    body {
        --color-primary: #0075c1;
        --color-primary-dark: #2c3e50;
        --color-success: #28a745;
        --color-success-hover: #218838;
        --color-danger: #dc3545;
        --color-danger-hover: #c82333;
        --color-warning: #ffc107;
        --color-warning-background: #fff3cd;
        --color-warning-border: #ffeaa7;
        --color-warning-text: #856404;
        --color-text-primary: #333;
        --color-text-secondary: #666;
        --color-text-dim: #666;
        --color-dim-bg: #f8f9fa;
        --color-primary-bg: #ccebff;
        --color-white: #fff;
        --color-black: #000;
        --color-input-readonly: #f0f0f0;

        --spacing-xs: 4px;
        --spacing-sm: 8px;
        --spacing-md: 12px;
        --spacing-lg: 16px;
        --spacing-xl: 20px;
        --spacing-xxl: 24px;
        --spacing-xxxl: 32px;
        --spacing-huge: 40px;

        --font-weight-normal: 400;
        --font-weight-medium: 500;
        --font-weight-semibold: 600;
        --font-weight-bold: 700;

        --font-family-base:
            'Open Sans',
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            sans-serif;
        --font-family-mono: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Courier New', monospace;

        --font-size-xs: 11px;
        --font-size-sm: 12px;
        --font-size-md: 14px;
        --font-size-lg: 16px;
        --font-size-xl: 18px;

        --border-radius-sm: 3px;
        --border-radius-md: 6px;
        --border-radius-lg: 8px;
        --border-radius-xl: 12px;

        --icon-base-size: 20px;
        
        font-family: var(--font-family-base);
        font-size: var(--font-size-md);
        margin: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    // #region Vendor Overrides
    .react-tiny-popover-container {
        z-index: 1200;
    }
    // #endregion
`;
